<script setup>
import { ref, computed } from "vue";
import { useChat } from "@/composables/useSidebar";
import { useContainerQuery } from "@/composables/useContainerQuery";

definePageMeta({
  layout: "main",
});

const { isChatOpen, isNotificationOpen } = useChat();
const mainSectionRef = ref(null);
// xxl (1400px) 기준으로 사용
const { isBelowBreakpoint } = useContainerQuery(mainSectionRef, "xxl");

// 1400px 초과일 때만 index.vue의 BettingStatus를 보여줌 (XXL 사이즈)
// 1400px 이하일 때는 ChartSection 내부에 렌더링됨
const showBettingStatusOutside = computed(() => !isBelowBreakpoint.value);

// 탭 상태 관리
const activeTab = ref("betting"); // 'betting' | 'ranking'

// 탭 클릭 핸들러
const handleTabClick = (tab) => {
  activeTab.value = tab;
};
</script>

<template>
  <div class="main">
    <main class="main__content">
      <div
        ref="mainSectionRef"
        class="main__section main__section--flex"
        :class="{
          'main__section--chat-open': isChatOpen || isNotificationOpen,
        }"
      >
        <!-- 차트 -->
        <MainChartSection :show-betting-status="false" />
        <!-- 베팅 상태 (항상 우측에 표시) -->
        <section class="betting-status">
          <MainBettingStatus />
        </section>
      </div>

      <div
        class="main__section"
        :class="{
          'main__section--chat-open': isChatOpen || isNotificationOpen,
        }"
      >
        <div class="main__section-wrapper">
          <ul class="tab__list">
            <li
              class="tab__item"
              :class="{ 'tab__item--active': activeTab === 'betting' }"
            >
              <button
                type="button"
                class="tab__btn"
                @click="handleTabClick('betting')"
              >
                <span class="tab__text">배팅이력</span>
              </button>
            </li>
            <li
              class="tab__item"
              :class="{ 'tab__item--active': activeTab === 'ranking' }"
            >
              <button
                type="button"
                class="tab__btn"
                @click="handleTabClick('ranking')"
              >
                <span class="tab__text">순위</span>
              </button>
            </li>
          </ul>
          <!-- 배팅이력 -->
          <MainBettingHistory v-show="activeTab === 'betting'" />
          <!-- 순위 -->
          <MainRankingHistory v-show="activeTab === 'ranking'" />
        </div>
      </div>

      <LayoutFooter
        :class="{
          'main__section--chat-open': isChatOpen || isNotificationOpen,
        }"
      />
    </main>

  </div>
</template>

<style>
@import "@/assets/scss/pages/main.scss";
</style>
